document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".top-col2__wrap .img__wrap img");
  const links = document.querySelectorAll(".top-col2__wrap .link__wrap a");

  links.forEach((link, index) => {
    link.addEventListener("mouseenter", () => {
      // すべてのimgからvisibleを外す
      images.forEach((img) => img.classList.remove("visible"));
      // index番目のimgにvisibleを付ける
      if (images[index]) {
        images[index].classList.add("visible");
      }
    });

    // マウスが外れた時に1枚目に戻す場合は以下を追加
    link.addEventListener("mouseleave", () => {
      images.forEach((img) => img.classList.remove("visible"));
      if (images[0]) {
        images[0].classList.add("visible");
      }
    });
  });
});

// ================================
// ハンバーガーメニューの処理
// ================================

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".header__wrap").forEach((wrap) => {
    const openBtn = wrap.querySelector(".openbtn");
    const spMenuDrawer = wrap.querySelector(".sp-menu-drawer");
    const bgBlack = wrap.querySelector(".bg-black");

    if (!openBtn || !spMenuDrawer || !bgBlack) return;

    // .openbtn クリック時
    openBtn.addEventListener("click", () => {
      const wasActive = spMenuDrawer.classList.contains("active");

      spMenuDrawer.classList.toggle("active");
      bgBlack.classList.toggle("active");
      spMenuDrawer.classList.toggle("active", !wasActive);
      openBtn.classList.toggle(
        "active",
        spMenuDrawer.classList.contains("active")
      );

      // body.fixed をメニュー状態に同期
      document.body.classList.toggle(
        "fixed",
        spMenuDrawer.classList.contains("active")
      );
    });

    // .bg-black クリック時
    bgBlack.addEventListener("click", () => {
      const wasActive = spMenuDrawer.classList.contains("active");

      spMenuDrawer.classList.toggle("active");
      openBtn.classList.toggle("active");
      spMenuDrawer.classList.toggle("active", !wasActive);
      bgBlack.classList.toggle(
        "active",
        spMenuDrawer.classList.contains("active")
      );

      // body.fixed をメニュー状態に同期
      document.body.classList.toggle(
        "fixed",
        spMenuDrawer.classList.contains("active")
      );
    });
  });
});

const backToTop = document.getElementById("backToTop");

// スクロール量に応じて表示/非表示
const toggleBtn = () => {
  // 200px以上スクロールしたら表示
  if (window.scrollY > 200) {
    backToTop.style.display = "inline-flex";
  } else {
    backToTop.style.display = "none";
  }
};
toggleBtn();
window.addEventListener("scroll", toggleBtn, { passive: true });

// クリックで最上部へスムーススクロール
backToTop.addEventListener("click", (e) => {
  e.preventDefault();
  // 対応ブラウザはスムース、それ以外は瞬時スクロール
  try {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } catch {
    window.scrollTo(0, 0);
  }
});
